/**
 * Converts a formatted price value into a numeric value for clickstream payloads.
 */
export const convertPriceStringToFloat = (price: unknown): number => {
  const cleanPriceString = String(price ?? "").replace(/[^\d.-]/g, "");
  return Number.parseFloat(cleanPriceString);
};
